import GestureHelper from './GestureHelper';

/**
 * @deprecated use regular 'click' event instead
 */
class Click extends GestureHelper {
  constructor(element: HTMLElement, onClick: (event: Event) => void) {
    super(element, { onClick });
  }
}

export default Click;
